import { Component, OnInit } from '@angular/core';
import { ObjetoExtra } from '../../model/ObjetoExtra';
import { PrensaService } from '../../services/prensa.service';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { RouterModule } from '@angular/router';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-extras',
  imports: [CommonModule, MatCardModule, RouterModule, MatProgressSpinnerModule],
  templateUrl: './extras.component.html',
  styleUrl: './extras.component.scss'
})
export class ExtrasComponent implements OnInit {

  extras: ObjetoExtra[] = [];
  showSpinner: boolean = true;

  constructor(private service: PrensaService) { }

  ngOnInit() {
    this.service.getExtras(0).subscribe(result => {
      this.extras = result.items;
      this.showSpinner = false;
    });
  }

}
